<template>
  <div class="nav-item-dropdown h-full">
    <a
      v-if="href"
      :class="
        twMerge(
          'px-2 py-4 text-sm xl:py-[22px] xl:text-base border-b-4 border-transparent flex items-center h-full',
          $attrs.class as string,
        )
      "
      :href="href"
    >
      <span class="font-bold block leading-none">
        {{ name }}
      </span>
    </a>

    <button
      v-else
      class="dropdown-trigger group relative flex h-full cursor-pointer select-none items-center gap-2 border-b-4 border-transparent px-2 py-4 text-sm xl:py-[22px] xl:text-base"
      tabindex="0"
      :aria-label="name"
      :aria-controls="`${menuId}`"
    >
      <span class="font-bold leading-none block" data-testid="navigation-item">
        {{ name }}
      </span>

      <div class="transition-all duration-300 group-focus:rotate-180">
        <!-- Triangle -->
        <div class="block w-2 overflow-hidden transition duration-300">
          <div
            class="bg-p-500 h-1.5 w-1.5 origin-top-left -rotate-45 transform"
          />
        </div>
      </div>
    </button>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

defineProps<{
  name: string
  href?: string
  menuId?: string
}>()
</script>

<style lang="scss">
.nav-item-dropdown {
  position: relative;

  &:has(.dropdown-trigger:focus)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.dropdown-trigger {
  position: relative;

  &:focus + .dropdown-menu {
    visibility: visible;
    opacity: 1;
  }

  &:has(a:focus) + .dropdown-menu {
    visibility: visible;
    opacity: 1;
  }
}

.dropdown-menu {
  position: absolute;
  top: 2.5rem;
  opacity: 0;
  visibility: hidden;
  transition:
    visibility 0.3s,
    opacity 0.3s ease;

  &:has(a:active),
  &:has(a:focus),
  &:has(a:hover) {
    display: block;
    visibility: visible !important;
    opacity: 1;
  }
}
</style>
